export class Sprite {
}
